import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { ErrorToast } from "../../components/toast/Toasts";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import {
  findOrderLabelingById,
  findOrderLabelingViewById,
  updateOrderLabeling,
} from "./services/orderLabeling.services";
import {
  clearOrderLabelingDetail,
  setCloseDeleteDialog,
} from "./orderLabelingSlice";
import OrderLabelingArray from "./OrderLabelingArray";
import { findAllActiveItem } from "../item/services/item.services";
// import OrderLabelingArray from "./OrderLabelingArray";

const GenerateOrderLabeling: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const orderId = location?.state?.ID;

  const loading = useAppSelector((state) => state.orderLabeling?.loading);
  const orderLabelingDetail = useAppSelector(
    (state) => state.orderLabeling?.orderLabelingDetail,
  );

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    if (orderId) {
      dispatch(findOrderLabelingViewById({ order_id: orderId }));
    }
    dispatch(findAllActiveItem());

    return () => {
      dispatch(clearOrderLabelingDetail());
      dispatch(setCloseDeleteDialog());
    };
  }, [orderId, dispatch]);

  useEffect(() => {
    if (orderLabelingDetail) {
      setFormKey(formKey + 1);
    }
  }, [orderLabelingDetail]);

  const handleGenerateLabel = () => {
    if (orderId) {
      dispatch(findOrderLabelingById({ order_id: orderId }));
    }
  };

  const handleSubmit = async (values: any) => {
    const payload = {
      order_id: values.order_id,
      GrossWeight: values?.GrossWeight || 0,
      LessWeight: values?.LessWeight || 0,
      NetWeight: values?.NetWeight || 0,
      ORDERLabeling:
        values.ORDERLabeling?.map((item: any) => ({
          id: item.id,
          order_id: values.id,
          ItemID: item.ItemID,
          ItemName: item.ItemName,
          Weight: item.Weight,
          Pcs: item.Pcs,
          CustomerRate: item.CustomerRate,
          Total: item.Total,
        })) || [],
    };

    try {
      const response = await dispatch(updateOrderLabeling(payload));
      if (response?.meta?.requestStatus === "fulfilled") {
        if (orderId) {
          dispatch(findOrderLabelingViewById({ order_id: orderId }));
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      ErrorToast("Failed to update order labeling");
    }
  };

  const handleFormClose = () => {
    navigate("/orderlabeling");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={orderLabelingDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "24.6%" },
                  { width: "24.6%" },
                  { width: "24.6%" },
                  { width: "24.6%" },
                ]}
              >
                <GridLayoutItem colSpan={4}>
                  <Typography.h4>Label Generate</Typography.h4>
                </GridLayoutItem>

                <GridLayoutItem colSpan={4}>
                  {orderLabelingDetail?.order_id && (
                    <Typography.h5>
                      No :{" "}
                      <span style={{ color: "green" }}>
                        {orderLabelingDetail.order_id}
                      </span>
                    </Typography.h5>
                  )}
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    marginTop: "22px",
                    justifyContent: "end",
                  }}
                >
                  Gross Weight (gm):
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="GrossWeight"
                    // label="Gross Weight (gm)"
                    placeholder="0.000"
                    format="n3"
                    component={FormNumericTextField}
                    // astrike={true}
                    // validator={requiredValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}></GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    marginTop: "22px",
                    justifyContent: "end",
                  }}
                >
                  Less Weight (gm):
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="LessWeight"
                    // label="Less Weight (gm)"
                    placeholder="0.000"
                    format="n3"
                    component={FormNumericTextField}
                    // astrike={true}
                    // validator={requiredValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}></GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    marginTop: "22px",
                    justifyContent: "end",
                  }}
                >
                  Net Weight (gm):
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="NetWeight"
                    // label="Net Weight (gm)"
                    placeholder="0.000"
                    format="n3"
                    component={FormNumericTextField}
                    // astrike={true}
                    // validator={requiredValidator}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>

            {/* Order Labeling Array Section */}
            <ShadowCard style={{ marginTop: 10 }}>
              <FieldArray
                formRenderProps={formRenderProps}
                component={OrderLabelingArray}
                name="ORDERLabeling"
              />

              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "50%" }, { width: "50%" }]}
              >
                <GridLayoutItem
                  colSpan={2}
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <Button
                    type="button"
                    fillMode={"solid"}
                    themeColor={"primary"}
                    style={{ marginRight: 4 }}
                    onClick={handleFormClose}
                  >
                    Go To Generate Label List
                  </Button>
                  <ButtonWithLoading
                    label="Generate"
                    type="button"
                    style={{ marginRight: 4 }}
                    onClick={handleGenerateLabel}
                    disabled={loading}
                    loading={loading}
                  />
                  <ButtonWithLoading
                    label="Update"
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default GenerateOrderLabeling;
